<div class="page-layout">

  <!-- ====================== HEADER ====================== -->
  <div class="page-header">
    <div class="header-title-group">
      <h2 class="cyber-title">&gt;_ DIRECTORIO DE PROYECTOS</h2>
    </div>

    <div class="header-actions">
      <button class="btn primary btn-glow" (click)="openModal()">
        &gt;_ NUEVA ESTIMACIÓN
      </button>
    </div>
  </div>

  <!-- ====================== COMMAND AREA ====================== -->
  <div class="command-area" *ngIf="!isInitialLoading">

    <!-- Barra principal: búsqueda + toggle filtros + sort -->
    <div class="command-bar">
      <input
        #searchInput
        type="text"
        class="form-control search-input"
        placeholder="Buscar por nombre o descripción..."
        [value]="q"
        (input)="onSearchInput(searchInput.value)"
        aria-label="Buscar proyectos" />

      <button
        #filtersBtn
        type="button"
        class="btn secondary filters-toggle"
        [class.is-active]="activeChips.length > 0"
        [class.is-open]="filtersOpen"
        [attr.aria-expanded]="filtersOpen"
        aria-controls="filters-panel"
        (click)="toggleFilters()">
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path d="M3 6h18M6 12h12M10 18h4"
                stroke="currentColor" stroke-width="2"
                fill="none" stroke-linecap="round"/>
        </svg>
        <span>Filtros</span>
        <span *ngIf="activeChips.length > 0" class="filters-count">
          ({{ activeChips.length }})
        </span>
      </button>

      <select
        #sortSel
        class="form-control sort-select"
        [value]="sort"
        (change)="onSortChange(sortSel.value)"
        aria-label="Ordenar por">
        <option *ngFor="let o of sortOptions" [value]="o.value">{{ o.label }}</option>
      </select>
    </div>

    <!-- Panel desplegable de filtros -->
    <div
      #filtersPanel
      id="filters-panel"
      class="filters-panel"
      [class.is-open]="filtersOpen"
      role="region"
      aria-label="Filtros avanzados">

      <button
        type="button"
        class="filters-panel-close"
        (click)="closeFilters()"
        aria-label="Cerrar panel de filtros"
        title="Cerrar">×</button>

      <div class="filters-grid">
        <div class="filter-field">
          <label for="flt-society">Sociedad</label>
          <select
            #societySel
            id="flt-society"
            class="form-control"
            [value]="societyId || ''"
            (change)="onSocietyChange(societySel.value)">
            <option value="">Todas</option>
            <option *ngFor="let s of societies" [value]="s.id">{{ s.name }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label for="flt-type">Tipo</label>
          <select
            #typeSel
            id="flt-type"
            class="form-control"
            [value]="typeId || ''"
            (change)="onTypeChange(typeSel.value)">
            <option value="">Todos</option>
            <option *ngFor="let t of types" [value]="t.id">{{ t.name }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label for="flt-system">Sistema</label>
          <select
            #systemSel
            id="flt-system"
            class="form-control"
            [value]="systemId || ''"
            (change)="onSystemChange(systemSel.value)">
            <option value="">Todos</option>
            <option *ngFor="let s of systems" [value]="s.id">{{ s.name }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Chips de filtros activos -->
    <div class="active-chips" *ngIf="activeChips.length > 0">
      <span
        *ngFor="let chip of activeChips; trackBy: trackByChipKey"
        class="cyber-chip">
        {{ chip.label }}
        <button
          type="button"
          class="cyber-chip-remove"
          (click)="removeFilter(chip.key)"
          [attr.aria-label]="'Quitar filtro ' + chip.label"
          title="Quitar filtro">×</button>
      </span>

      <button
        type="button"
        class="btn secondary sm clear-all-btn"
        (click)="clearFilters()"
        title="Limpiar todos los filtros activos">
        × Limpiar todo
      </button>
    </div>
  </div>

  <!-- ====================== BOOT-SEQUENCE (1ª carga) ====================== -->
  <div class="boot-sequence" *ngIf="isInitialLoading">
    <p>&gt;_ Conectando con la base de datos...</p>
    <p>&gt;_ Extrayendo repositorios de proyectos...</p>
    <p>&gt;_ Cargando nodos <span class="blink">_</span></p>
  </div>

  <!-- ====================== LISTADO ====================== -->
  <div
    class="repo-list"
    *ngIf="!isInitialLoading"
    [class.is-reloading]="isReloading">

    <div *ngIf="proyectos.length === 0" class="empty-state">
      <ng-container *ngIf="hasActiveFilters(); else noProjects">
        &gt;_ Ningún proyecto coincide con los filtros activos.
      </ng-container>
      <ng-template #noProjects>
        &gt;_ No se encontraron proyectos.
      </ng-template>
    </div>

    <div
      *ngFor="let proyecto of proyectos; trackBy: trackById"
      class="repo-item"
      (click)="loadProyecto(proyecto.id)">

      <div class="repo-main">
        <svg viewBox="0 0 24 24" class="repo-icon" width="24" height="24" aria-hidden="true">
          <path fill="currentColor"
                d="M3 3h8v8H3zm10 0h8v8h-8zM3 13h8v8H3zm15 0h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"/>
        </svg>

        <div class="repo-info">
          <h3>{{ proyecto.name }}</h3>
          <p class="repo-desc">{{ proyecto.description || 'Sin descripción detallada del alcance...' }}</p>

          <div class="repo-progress" [ngClass]="getProgressClass(proyecto)">
            <ng-container *ngIf="proyecto.totalEstimatedHours > 0; else noEst">
              <span class="progress-label">
                EST: {{ proyecto.totalEstimatedHours }}h · EJE: {{ proyecto.totalExecutedHours }}h
              </span>
              <div class="progress-track" aria-hidden="true">
                <div class="progress-fill" [style.width.%]="fillWidth(proyecto)"></div>
              </div>
              <span class="progress-pct">{{ computePercent(proyecto) }}%</span>
            </ng-container>
            <ng-template #noEst>
              <span class="progress-empty">Sin estimación registrada</span>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="repo-meta">
        <span *ngIf="proyecto.department?.society"
              class="cyber-badge society"
              title="Sociedad">{{ proyecto.department?.society?.name }}</span>

        <span *ngIf="proyecto.department"
              class="cyber-badge dept"
              title="Departamento">{{ proyecto.department?.name }}</span>

        <span *ngIf="proyecto.type"
              class="cyber-badge type"
              title="Tipo">{{ proyecto.type?.name }}</span>
      </div>
    </div>
  </div>

  <!-- ====================== PAGINADOR ====================== -->
  <app-paginator
    *ngIf="!isInitialLoading && total > 0"
    [total]="total"
    [page]="page"
    [pageSize]="pageSize"
    [disabled]="isReloading"
    ariaLabel="Paginación del directorio de proyectos"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </app-paginator>

</div>

<app-modal-estimation-wizard
  *ngIf="showModal"
  (close)="closeModal()">
</app-modal-estimation-wizard>